import SupplierDetail from './SupplierDetail';

export default SupplierDetail;



// WEBPACK FOOTER //
// ./src/scenes/Suppliers/SupplierDetail/index.ts